import { CanDeactivateFn } from '@angular/router';
import { AccountEditorPage, unsavedAccountGuard } from './unsaved-account.guard';

// A loading or denied household shell may not have created its editor yet.
// Active editors still use their existing unsaved-change behaviour unchanged.
export const householdWorkspaceEditorGuard: CanDeactivateFn<AccountEditorPage | null> = (component, currentRoute, currentState, nextState) => {
  if (!component)
    return true;

  return unsavedAccountGuard(component, currentRoute, currentState, nextState);
};
